import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=c0fe9792"
import script from "./colors.vue?vue&type=script&lang=js"
export * from "./colors.vue?vue&type=script&lang=js"
import style0 from "./colors.vue?vue&type=style&index=0&id=c0fe9792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports